import React from 'react'
import ReactDOM from 'react-dom'
import SiteAlerts from '../misc/site_alerts'

document.addEventListener('DOMContentLoaded', () => {
  const mount = document.getElementById('site-alerts')
  ReactDOM.render(<SiteAlerts />, mount)
})
